<div class="scorm-wrap">
  <div id="title" class="fontSize18 title">
    <div class="back-btn-sight" id="backBtn"  (click)="goToLearningMap()" style="top:.2rem">
      <i class="fa fa-angle-left icon"></i>
    </div>
    <p>{{courseName}}</p>
    <div *ngIf="version==='微课' || version==='在线课'" (click)="changeLanguage()" class="change-language-button"></div>
  </div>

  <div class="scorm-body">
    <iframe id="scormPlayer" class="scormFrame" src="" allowfullscreen></iframe>
  </div>

</div>






// WEBPACK FOOTER //
// ./src/app/app-scorm/app-scorm.component.html